/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.BaseUnitResponseDto>;
export function request(body: defs.basics.BaseUnitRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseUnit/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
